import styled from "styled-components";
import { device } from '../../styles/devices'

export const ScrollHome = styled.div`
    margin-left: 9rem;
    margin-top: 5rem;

    @media ${device.tabletLarge}{
        margin-left: 4.4rem;
    }

    @media ${device.tablet}{
        display: none;
    }

    a{
        position: relative;    
        font-size: 1rem;
        line-height: 1.5rem;
        font-weight: var(--font-medium);
        color: var(--color-text);
        display: inline-block;
        transition: .2s ease-in;

        &:hover{
            color: var(--color-black-hover);
        }

        span{
            display: flex;
            align-items: center;
        }

        i.uil-mouse-alt{
            font-size: 1.5rem;
            margin-right: 0.2rem;
        }

        i.uil-arrow-down{
            position: absolute;
            right: -1.3rem;
            top: 0;
            font-size: 1.2rem;
            animation: arrow_animate 1s ease-in-out infinite 1s;
        }

        @keyframes arrow_animate {
            0%{
                top: -3px;
            }
            50%{
                top: 3px;
            }
            100%{
                top: -3px;
            }
        }
    }
`;